import React from 'react'
import Testimonials from '../components/Testimonials/Testimonials'

function TestimonialsPage() {
  return (
    <div className="page-wrapper">
        <Testimonials />
    </div>
  )
}

export default TestimonialsPage